import Vue from "vue";
import Router from "vue-router";
import HelloWorld from "@/components/HelloWorld";
import login from "@/view/login/login";
import main from "@/components/main/main";
// 主页
import home from "@/components/home/home";
import { checkBtn } from "@/utils/methods";
import { findMenuByUrl } from "@/utils/menu";

//解决刷新页面后点击统一菜单报错的问题；
Vue.use(Router);
//获取原型对象上的push函数
const originalPush = Router.prototype.push;
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

// 统一用变量router
const router = new Router({
  base: "supplychain_unity",
  routes: [
    {
      path: "/login",
      name: "login",
      redirect: "/",
      component: login,
    },
    {
      path: "/",
      name: "login",
      component: login,
    },

    {
      path: "/main",
      name: "main",
      redirect: "/main/home",
      component: main,
      children: [
        {
          path: "home",
          name: "home ",
          meta: {
            name: "主页",
          },
          component: () => import("../components/home/home.vue"),
        },
        // 角色管理
        {
          path: "rolepage",
          name: "rolepage",
          meta: {
            parentname: "权限管理",
            name: "角色管理",
          },
          component: () => import("../view/myinfo/rolepage/rolepage.vue"),
        },
        {
          path: "loginList",
          name: "loginList",
          meta: {
            parentname: "日志",
            name: "登录日志",
          },
          component: () =>
            import("../view/anomalQuery/loginList/loginList.vue"),
        },
        {
          path: "editList",
          name: "editList",
          meta: {
            parentname: "日志",
            name: "操作日志",
          },
          component: () => import("../view/anomalQuery/editList/editList.vue"),
        },
        // 用户管理
        {
          path: "userpage",
          name: "userpage",
          meta: {
            parentname: "权限管理",
            name: "用户管理",
          },
          component: () => import("../view/myinfo/userpage/userpage.vue"),
        },
        {
          path: "changepassword",
          name: "changepassword",
          meta: {
            parentname: "权限管理",
            name: "修改密码",
          },
          component: () =>
            import("../view/myinfo/changepassword/changepassword.vue"),
        },
        {
          path: "menupage",
          name: "menupage",
          meta: {
            parentname: "权限管理",
            name: "菜单权限",
          },
          component: () => import("../view/myinfo/menupage/menupage.vue"),
        },
        //**************************基础数据*************************、
        // 产品管理
        {
          path: "Product",
          name: "Product",
          meta: {
            parentname: "基础数据",
            name: "产品管理",
          },
          component: () => import("../view/baseDate/Product/Product.vue"),
        },
        //产品类别管理
        {
          path: "Category",
          name: "Category",
          meta: {
            parentname: "基础数据",
            name: "品牌管理",
          },
          component: () => import("../view/baseDate/Category/Category.vue"),
        },
        //包装管理
        {
          path: "Packing",
          name: "Packing",
          meta: {
            parentname: "基础数据",
            name: "包装管理",
          },
          component: () => import("../view/baseDate/Packing/Packing.vue"),
        },
        //经销商管理
        {
          path: "DealerController",
          name: "DealerController",
          meta: {
            parentname: "基础数据",
            name: "经销商管理",
            keepAlive: true, // 此组件需要被缓存
            isBack: false, //用于判断上一个页面是哪个
          },
          component: () =>
            import("../view/baseDate/DealerController/DealerController.vue"),
        },
        // 经销商管理的添加
        {
          path: "DealerControllerAdd",
          name: "DealerControllerAdd",
          meta: {
            parentname: "基础数据",
            name: "经销商管理",
            keepAlive: true, // 此组件需要被缓存
            isBack: false, //用于判断上一个页面是哪个
          },
          component: () => import("../view/baseDate/DealerController/add.vue"),
        },
        //工厂管理
        {
          path: "Factory",
          name: "Factory",
          meta: {
            parentname: "基础数据",
            name: "工厂管理",
          },
          component: () => import("../view/baseDate/Factory/Factory.vue"),
        },
        //工控机管理
        {
          path: "IpcController",
          name: "IpcController",
          meta: {
            parentname: "基础数据",
            name: "工控机管理",
          },
          component: () =>
            import("../view/baseDate/IpcController/IpcController.vue"),
        },
        //产线管理
        {
          path: "ProductLine",
          name: "ProductLine",
          meta: {
            parentname: "基础数据",
            name: "产线管理",
          },
          component: () =>
            import("../view/baseDate/ProductLine/ProductLine.vue"),
        },
        // 品种管理
        {
          path: "ProductVariety",
          name: "ProductVariety",
          meta: {
            parentname: "基础数据",
            name: "品种管理",
          },
          component: () =>
            import("../view/baseDate/ProductVariety/ProductVariety.vue"),
        },
        //班组管理
        {
          path: "ProductTeam",
          name: "ProductTeam",
          meta: {
            parentname: "基础数据",
            name: "班组管理",
          },
          component: () =>
            import("../view/baseDate/ProductTeam/ProductTeam.vue"),
        },
        //仓库管理
        {
          path: "Warehouse",
          name: "Warehouse",
          meta: {
            parentname: "基础数据",
            name: "仓库管理",
          },
          component: () => import("../view/baseDate/Warehouse/Warehouse.vue"),
        },
        //车间管理
        {
          path: "Workshop",
          name: "Workshop",
          meta: {
            parentname: "基础数据",
            name: "车间管理",
          },
          component: () => import("../view/baseDate/Workshop/Workshop.vue"),
        },
        //供应商管理
        {
          path: "Supplier",
          name: "Supplier",
          meta: {
            parentname: "基础数据",
            name: "供应商管理",
          },
          component: () => import("../view/baseDate/Supplier/Supplier.vue"),
        },
        //销售区域
        {
          path: "SaleArea",
          name: "SaleArea",
          meta: {
            parentname: "基础数据",
            name: "销售区域管理",
          },
          component: () => import("../view/baseDate/SaleArea/SaleArea.vue"),
        },
        //*************************仓库管理*************************、

        {
          path: "prodinstorage",
          name: "prodinstorage",
          meta: {
            parentname: "仓储管理",
            name: "生产入库",
          },
          component: () =>
            import("../view/inventory/prodinstorage/prodinstorage.vue"),
        },
        {
          path: "changelibrary",
          name: "changelibrary",
          meta: {
            parentname: "仓储管理",
            name: "整垛换库",
          },
          component: () =>
            import("../view/inventory/changelibrary/changelibrary.vue"),
        },
        {
          path: "scrapped",
          name: "scrapped",
          meta: {
            parentname: "仓储管理",
            name: "报废",
          },
          component: () => import("../view/inventory/scrapped/scrapped.vue"),
        },
        {
          path: "replace",
          name: "replace",
          meta: {
            parentname: "仓储管理",
            name: "替换",
          },
          component: () => import("../view/inventory/replace/replace.vue"),
        },
        {
          path: "unstack",
          name: "unstack",
          meta: {
            parentname: "仓储管理",
            name: "拆垛",
          },
          component: () => import("../view/inventory/unstack/unstack.vue"),
        },
        {
          path: "stackingAndPatching",
          name: "stackingAndPatching",
          meta: {
            parentname: "仓储管理",
            name: "组垛&补垛",
          },
          component: () =>
            import(
              "../view/inventory/stackingAndPatching/stackingAndPatching.vue"
            ),
        },
        {
          path: "wholeSupportChange",
          name: "wholeSupportChange",
          meta: {
            parentname: "仓储管理",
            name: "整垛换垛",
          },
          component: () =>
            import(
              "../view/inventory/wholeSupportChange/wholeSupportChange.vue"
            ),
        },
        {
          path: "backoutstorage",
          name: "backoutstorage",
          meta: {
            parentname: "仓储管理",
            name: "返工出库",
          },
          component: () =>
            import("../view/inventory/backoutstorage/backoutstorage.vue"),
        },
        {
          path: "differenPack",
          name: "differenPack",
          meta: {
            parentname: "仓储管理",
            name: "拆补包装",
          },
          component: () =>
            import("../view/inventory/differenPack/differenPack.vue"),
        },
        {
          path: "scrap",
          name: "scrap",
          meta: {
            parentname: "仓储管理",
            name: "报废",
          },
          component: () => import("../view/inventory/scrap/scrap.vue"),
        },
        {
          path: "salereturninstorage",
          name: "salereturninstorage",
          meta: {
            parentname: "仓储管理",
            name: "销售退库",
          },
          component: () =>
            import(
              "../view/inventory/salereturninstorage/salereturninstorage.vue"
            ),
        },
        {
          path: "tdwoow", //Three-dimensional warehouse out of the warehouse
          name: "tdwoow",
          meta: {
            parentname: "仓储管理",
            name: "立体仓出库",
          },
          component: () =>
            import("../view/inventory/TDWoutstorage/TDWoutstorage.vue"),
        },
        {
          path: "cooos", //Closed orders out of stock
          name: "cooos",
          meta: {
            parentname: "仓储管理",
            name: "平仓订单出库",
          },
          component: () =>
            import("../view/inventory/COOOSoutstorage/COOOSoutstorage.vue"),
        },
        {
          path: "ccootw", //Closed customer out of the warehouse
          name: "ccootw",
          meta: {
            parentname: "仓储管理",
            name: "平仓客户出库",
          },
          component: () =>
            import("../view/inventory/CCOOTWoutstorage/CCOOTWoutstorage.vue"),
        },
        {
          path: "transferoutstorage",
          name: "transferoutstorage",
          meta: {
            parentname: "仓储管理",
            name: "调拨出库",
          },
          component: () =>
            import(
              "../view/inventory/transferoutstorage/transferoutstorage.vue"
            ),
        },
        {
          path: "TransferStore",
          name: "TransferStore",
          meta: {
            parentname: "仓储管理",
            name: "调拨出库",
          },
          component: () =>
            import("../view/inventory/TransferStore/TransferStore.vue"),
        },
        {
          path: "AllocationWarehouse",
          name: "AllocationWarehouse",
          meta: {
            parentname: "仓储管理",
            name: "调拨入库",
          },
          component: () =>
            import(
              "../view/inventory/AllocationWarehouse/AllocationWarehouse.vue"
            ),
        },
        {
          path: "invcheckmanager",
          name: "invcheckmanager",
          meta: {
            parentname: "仓储管理",
            name: "库存查询",
          },
          component: () =>
            import("../view/inventory/invcheckmanager/invcheckmanager.vue"),
        },
        {
          path: "shipmentScanRate",
          name: "shipmentScanRate",
          meta: {
            parentname: "仓储管理",
            name: "发货扫码率报表",
          },
          component: () =>
            import("../view/inventory/shipmentScanRate/shipmentScanRate.vue"),
        },
        {
          path: "unqualified",
          name: "unqualified",
          meta: {
            parentname: "仓储管理",
            name: "不合格出库",
          },
          component: () =>
            import("../view/inventory/unqualified/unqualified.vue"),
        },
        //破损替换
        {
          path: "wornReplace",
          name: "wornReplace",
          meta: {
            parentname: "仓储管理",
            name: "破损替换",
          },
          component: () =>
            import("../view/inventory/wornReplace/wornReplace.vue"),
        },
        //返工单号
        {
          path: "reworkOrderNo",
          name: "reworkOrderNo",
          meta: {
            parentname: "仓储管理",
            name: "返工单号",
          },
          component: () =>
            import("../view/inventory/reworkOrderNo/reworkOrderNo.vue"),
        },
        //    ************************生产管理模块
        //生产计划管理
        {
          path: "ProductPlan",
          name: "ProductPlan",
          meta: {
            parentname: "生产管理",
            name: "生产订单",
          },
          component: () =>
            import("../view/ProductionManger/ProductPlan/ProductPlan.vue"),
        },
        {
          path: "ProductPlanPage",
          name: "ProductPlanPage",
          meta: {
            parentname: "生产管理",
            name: "生产计划管理页面",
          },
          component: () =>
            import(
              "../view/ProductionManger/ProductPlanPage/ProductPlanPage.vue"
            ),
        },
        //生产任务管理
        {
          path: "Protaskman",
          name: "Protaskman",
          meta: {
            parentname: "生产管理",
            name: "生产批次",
          },
          component: () =>
            import("../view/ProductionManger/Protaskman/Protaskman.vue"),
        },
        //生产数据管理
        {
          path: "ProductionData",
          name: "ProductionData",
          meta: {
            parentname: "生产管理",
            name: "生产数据",
          },
          component: () =>
            import(
              "../view/ProductionManger/ProductionData/ProductionData.vue"
            ),
        },
        //生产报表
        {
          path: "productionReport",
          name: "productionReport",
          meta: {
            parentname: "生产管理",
            name: "生产报表",
          },
          component: () =>
            import(
              "../view/ProductionManger/ProductionReport/productionReport.vue"
            ),
        },
        //重发top
        {
          path: "batchCodeQuery",
          name: "batchCodeQuery",
          meta: {
            parentname: "稽查工具",
            name: "批次溯源查询",
          },
          component: () =>
            // import ('../view/ProductionManger/TopReturn/TopReturn.vue')
            import("../view/anomalQuery/batchCodeQuery/batchCodeQuery.vue"),
        },
        //稽查记录
        {
          path: "auditRecord",
          name: "auditRecord",
          meta: {
            parentname: "稽查工具",
            name: "窜货提报记录",
          },
          component: () =>
            import("../view/anomalQuery/auditRecord/auditRecord.vue"),
        },
        {
          path: "recordDetail",
          name: "recordDetail",
          meta: {
            parentname: "稽查工具",
            name: "窜货提报记录",
            keepAlive: true, // 此组件需要被缓存
            isBack: false, //用于判断上一个页面是哪个
          },
          component: () =>
            import("../view/anomalQuery/auditRecord/recordDetail.vue"),
        },
        //溯源查询
        {
          path: "historyQuery",
          name: "historyQuery",
          meta: {
            parentname: "稽查工具",
            name: "码溯源查询",
          },
          component: () =>
            import("../view/anomalQuery/historyQuery/historyQuery.vue"),
        },
        {
          path: "batchQueryTray",
          name: "batchQueryTray",
          meta: {
            parentname: "稽查工具",
            name: "批次查询托盘",
          },
          component: () =>
            import(
              "../view/anomalQuery/batchqueryconsignmentcode/batchqueryconsignmentcode.vue"
            ),
        },
        {
          path: "anomalRecord",
          name: "anomalRecord",
          meta: {
            parentname: "异常监控",
            name: "系统异常",
          },
          component: () =>
            import("../view/anomalQuery/system/anomalRecord.vue"),
        },
        {
          path: "fleeingGoods",
          name: "fleeingGoods",
          meta: {
            parentname: "异常监控",
            name: "窜货明细",
          },
          component: () =>
            import("../view/anomalQuery/anomalRecord/fleeingGoods.vue"),
        },
        {
          path: "codecheckrecord",
          name: "codecheckrecord",
          meta: {
            parentname: "稽查工具",
            name: "扫码稽查记录",
          },
          component: () =>
            import("../view/anomalQuery/codecheckrecord/codecheckrecord.vue"),
        },
        {
          path: "anomalRecord",
          name: "system",
          meta: {
            parentname: "异常监控",
            name: "系统异常",
          },
          component: () =>
            import("../view/anomalQuery/system/anomalRecord.vue"),
        },
        {
          path: "anomalRecord",
          name: "mobile",
          meta: {
            parentname: "异常监控",
            name: "系统异常",
          },
          component: () =>
            import("../view/anomalQuery/mobile/anomalRecord.vue"),
        },
        //级别查询
        {
          path: "levelQuery",
          name: "levelQuery",
          meta: {
            parentname: "生产管理",
            name: "级别查询",
          },
          component: () =>
            import("../view/ProductionManger/levelQuery/levelQuery.vue"),
        },
        //推送限制管理
        {
          path: "pushLimitControl",
          name: "pushLimitControl",
          meta: {
            parentname: "推送限制管理",
            name: "推送限制管理",
          },
          component: () => import("../view/pushLimitControl/index.vue"),
        },
        //************************码包管理模块*************************
        //码包申请
        {
          path: "codeApply",
          name: "codeApply",
          meta: {
            parentname: "码包管理",
            name: "码包申请",
          },
          component: () => import("../view/codeManage/codeApply/codeApply.vue"),
        },
        //码包审核
        {
          path: "codeAudit",
          name: "codeAudit",
          meta: {
            parentname: "码包管理",
            name: "码包审核",
          },
          component: () => import("../view/codeManage/codeAudit/codeAudit.vue"),
        },
        //审批配置
        {
          path: "workflowConfig",
          name: "workflowConfig",
          meta: {
            parentname: "码包管理",
            name: "审批配置",
          },
          component: () =>
            import("../view/codeManage/workflowConfig/workflowConfig.vue"),
        },
        //码包下载
        {
          path: "codeDownload",
          name: "codeDownload",
          meta: {
            parentname: "码包管理",
            name: "码包下载",
          },
          component: () =>
            import("../view/codeManage/codeDownload/codeDownload.vue"),
        },
        //码规格配置
        {
          path: "tagConfig",
          name: "tagConfig",
          meta: {
            parentname: "码包管理",
            name: "码规格",
          },
          component: () => import("../view/codeManage/tagConfig/tagConfig.vue"),
        },
        //码印刷规格配置
        {
          path: "tagTemplateConfig",
          name: "tagTemplateConfig",
          meta: {
            parentname: "码包管理",
            name: "码印刷规格",
          },
          component: () =>
            import(
              "../view/codeManage/tagTemplateConfig/tagTemplateConfig.vue"
            ),
        },
        //工控机码包查看
        {
          path: "ipcCode",
          name: "ipcCode",
          meta: {
            parentname: "码包管理",
            name: "工控机码包查看",
          },
          component: () =>
            import("../view/codeManage/ipcCode/ipcCode.vue"),
        },
      ],
    },
  ],
});

// 全局按钮权限自动分发
router.beforeEach((to, from, next) => {
  let menuList = [];
  try {
    menuList = JSON.parse(localStorage.getItem("homePagemenus") || "[]");
  } catch (e) {}
  const menuKey = to.name;
  const menu = findMenuByUrl(menuList, menuKey);
  if (menu && menu.children) {
    localStorage.setItem("btnList", JSON.stringify(checkBtn(menu.children)));
  } else {
    localStorage.setItem("btnList", JSON.stringify(checkBtn([])));
  }
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js